import script from "./LayoutApp.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutApp.vue?vue&type=script&setup=true&lang=js"

import "./LayoutApp.vue?vue&type=style&index=0&id=3939cdd5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3939cdd5"]])

export default __exports__